import { baseURL } from "./Axios";

export const imageURL = `${baseURL}/images`;

export const displayImage = (filename) => {
  if (filename) {
    return `${imageURL}/${filename}`;
  }
};

export const countriesData = [
  { name: "United States", code: "+1", alpha2: "US" },
  { name: "United Kingdom", code: "+44", alpha2: "GB" },
  { name: "Algeria", code: "+213", alpha2: "DZ" },
  { name: "Angola", code: "+244", alpha2: "AO" },
  { name: "Benin", code: "+229", alpha2: "BJ" },
  { name: "Botswana", code: "+267", alpha2: "BW" },
  { name: "Burkina Faso", code: "+226", alpha2: "BF" },
  { name: "Burundi", code: "+257", alpha2: "BI" },
  { name: "Cabo Verde", code: "+238", alpha2: "CV" },
  { name: "Cameroon", code: "+237", alpha2: "CM" },
  { name: "Central African Republic", code: "+236", alpha2: "CF" },
  { name: "Chad", code: "+235", alpha2: "TD" },
  { name: "Comoros", code: "+269", alpha2: "KM" },
  { name: "Congo (Congo-Brazzaville)", code: "+242", alpha2: "CG" },
  { name: "Congo (Congo-Kinshasa)", code: "+243", alpha2: "CD" },
  { name: "Djibouti", code: "+253", alpha2: "DJ" },
  { name: "Egypt", code: "+20", alpha2: "EG" },
  { name: "Equatorial Guinea", code: "+240", alpha2: "GQ" },
  { name: "Eritrea", code: "+291", alpha2: "ER" },
  { name: "Eswatini (Swaziland)", code: "+268", alpha2: "SZ" },
  { name: "Ethiopia", code: "+251", alpha2: "ET" },
  { name: "Gabon", code: "+241", alpha2: "GA" },
  { name: "Gambia", code: "+220", alpha2: "GM" },
  { name: "Ghana", code: "+233", alpha2: "GH" },
  { name: "Guinea", code: "+224", alpha2: "GN" },
  { name: "Guinea-Bissau", code: "+245", alpha2: "GW" },
  { name: "Ivory Coast (Côte d'Ivoire)", code: "+225", alpha2: "CI" },
  { name: "Kenya", code: "+254", alpha2: "KE" },
  { name: "Lesotho", code: "+266", alpha2: "LS" },
  { name: "Liberia", code: "+231", alpha2: "LR" },
  { name: "Libya", code: "+218", alpha2: "LY" },
  { name: "Madagascar", code: "+261", alpha2: "MG" },
  { name: "Malawi", code: "+265", alpha2: "MW" },
  { name: "Mali", code: "+223", alpha2: "ML" },
  { name: "Mauritania", code: "+222", alpha2: "MR" },
  { name: "Mauritius", code: "+230", alpha2: "MU" },
  { name: "Morocco", code: "+212", alpha2: "MA" },
  { name: "Mozambique", code: "+258", alpha2: "MZ" },
  { name: "Namibia", code: "+264", alpha2: "NA" },
  { name: "Niger", code: "+227", alpha2: "NE" },
  { name: "Nigeria", code: "+234", alpha2: "NG" },
  { name: "Rwanda", code: "+250", alpha2: "RW" },
  { name: "São Tomé and Príncipe", code: "+239", alpha2: "ST" },
  { name: "Senegal", code: "+221", alpha2: "SN" },
  { name: "Seychelles", code: "+248", alpha2: "SC" },
  { name: "Sierra Leone", code: "+232", alpha2: "SL" },
  { name: "Somalia", code: "+252", alpha2: "SO" },
  { name: "South Africa", code: "+27", alpha2: "ZA" },
  { name: "South Sudan", code: "+211", alpha2: "SS" },
  { name: "Sudan", code: "+249", alpha2: "SD" },
  { name: "Tanzania", code: "+255", alpha2: "TZ" },
  { name: "Togo", code: "+228", alpha2: "TG" },
  { name: "Tunisia", code: "+216", alpha2: "TN" },
  { name: "Uganda", code: "+256", alpha2: "UG" },
  { name: "Zambia", code: "+260", alpha2: "ZM" },
  { name: "Zimbabwe", code: "+263", alpha2: "ZW" },
];

export const ShippingPolicies = () => {
  return (
    <div className="space-y-5">
      {/* <p className="text-gray-500">
                For all orders exceeding a value of 1,000GHS shipping is offered for free.
            </p> */}

      <p className="text-gray-500">
        Returns will be accepted for up to 10 days of Customer’s receipt or
        tracking number on unworn items. You, as a Customer, are obliged to
        inform us via email before you return the item.
      </p>
      <p className="text-gray-500">
        Otherwise, standard shipping charges apply. Check out our delivery Terms
        & Conditions for more details.
      </p>
    </div>
  );
};

export const ReturnPolicies = () => {
  return (
    <div className="space-y-5">
      <p className="text-gray-500">
        Returns will be accepted for up to 10 days of Customer’s receipt or
        tracking number on unworn items. You, as a Customer, are obliged to
        inform us via email before you return the item, only in the case of:
      </p>

      <ul className="list-inside list-decimal text-gray-500 ml-6">
        <li>Received the wrong item.</li>
        <li> Item arrived not as expected (ie. damaged packaging).</li>
        <li>Item had defects.</li>
        <li>Over delivery time.</li>
        <li>
          The shipper does not allow the goods to be inspected before payment.
        </li>
      </ul>

      <p className="text-gray-500">
        The returned product(s) must be in the original packaging, safety
        wrapped, undamaged and unworn. This means that the item(s) must be
        safely packed in a carton box for protection during transport, possibly
        the same carton used to ship to you as a customer.
      </p>
    </div>
  );
};

// Tabs in product Detailsexpo
export const tabs = ["Description", "Shipping & Returns", "Return Policies"];

// Nav Links

export const navLinks = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Shop",
    path: "/shop",
  },
  {
    title: "Bundles",
    path: "/bundles",
  },
  {
    title: "About Us",
    path: "/pages/about-us",
  },
  {
    title: "Contact",
    path: "/pages/contact-us",
  },
  // ,
  // {
  //   title: "Order Tracking",
  //   path: "/order-tracking"
  // }
];
